import { supabase } from "@/integrations/supabase/client";
import { collectBrowserEnvironment } from "@/utils/environmentInfo";
import { logger } from "@/services/logger";

export const ACTION_TYPES = {
  ADDRESS_CREATED: 'ADDRESS_CREATED',
  ADDRESS_UPDATED: 'ADDRESS_UPDATED',
  BULK_IMPORT_ADDED: 'BULK_IMPORT_ADDED',
  CART_SAVED: 'CART_SAVED',
  ORDER_EXPORTED: 'ORDER_EXPORTED',
  ORDER_MARKED_PAID: 'ORDER_MARKED_PAID',
  ORDER_SUBMITTED: 'ORDER_SUBMITTED',
  PASSWORD_RESET_COMPLETED: 'PASSWORD_RESET_COMPLETED',
  PASSWORD_RESET_REQUESTED: 'PASSWORD_RESET_REQUESTED',
  USER_LOGIN: 'USER_LOGIN',
  USER_LOGOUT: 'USER_LOGOUT',
  USER_REGISTRATION: 'USER_REGISTRATION',
};

export interface LogActivityParams {
  userId: string;
  actionType: string;
  details?: Record<string, unknown>;
  includeEnvironment?: boolean;  // デフォルトtrue
}

/**
 * Activity Logを記録（環境情報付き）
 */
export async function logActivity({
  userId,
  actionType,
  details = {},
  includeEnvironment = true
}: LogActivityParams): Promise<void> {
  try {
    const enhancedDetails = { ...details };

    // Phase 1: 基本セキュリティ情報 + Issue #313追加情報
    if (includeEnvironment) {
      const envInfo = collectBrowserEnvironment();
      enhancedDetails.security = envInfo.security;
      enhancedDetails.user_agent = envInfo.user_agent;
      enhancedDetails.session = envInfo.session;
      enhancedDetails.page = envInfo.page;
      enhancedDetails.platform = envInfo.platform;
      // Issue #313: 表示言語、デバイス情報、ネットワーク情報
      enhancedDetails.display_language = envInfo.display_language;
      enhancedDetails.device = envInfo.device;
      if (envInfo.network) {
        enhancedDetails.network = envInfo.network;
      }
    }

    const { error } = await supabase.from('user_activity_logs').insert({
      user_id: userId,
      action_type: actionType,
      details: enhancedDetails
    });

    if (error) {
      logger.error(`Failed to log activity: ${actionType}`, error);
    }
  } catch (error) {
    logger.error(`Exception while logging activity: ${actionType}`, error);
  }
}
